export function getServerApplicationContext<T>(caller: T) {
  if (!globalThis.initializeServerApplicationContext) {
    throw new Error('Application context is not defined');
  }

  return globalThis.initializeServerApplicationContext(caller);
}

export function getServerApplicationConfig() {
  if (!globalThis.initializeServerApplicationConfig) {
    throw new Error('Application config is not defined');
  }

  return globalThis.initializeServerApplicationConfig();
}
